export default __webpack_public_path__ + "static/media/faux_fur_type.b561d695.jpeg";